import { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import authService from "../../Auth/Services/AuthService";
import { Bars3Icon } from "@heroicons/react/24/outline";
import { useUser } from "../../../Utility/userContext";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, refreshUser } = useUser();
  const userInitial = user?.userName?.[0]?.toUpperCase() ?? "?";

  const getPageTitle = (path) => {
    if (path === "/dashboard" || path === "/dashboard/") return "Dashboard";
    if (path.includes("Preview")) return "Survey Preview";
    if (path.includes("Assessment-List")) return "Assessment List";
    if (path.includes("Add-Questions")) return "Add Questions";
    if (path.includes("build-analytics")) return "Build Analytics";
    if (path.includes("reports")) return "Reports";

    // Fallback: Format unknown routes (e.g., "/dashboard/plans" -> "Plans")
    const segment = path.split("/").pop();
    return segment ? segment.replace(/-/g, " ").replace(/\b\w/g, l => l.toUpperCase()) : "Portal";
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = async () => {
    try {
      await authService.logout();
    } catch (error) { }
    finally {
      navigate("/");
      refreshUser();
      setMenuOpen(false);
      CustomToast("success", "Logout successful.");
    }
  };

  return (
    <nav className="sticky top-0 z-50 bg-white shadow-sm">
      <div className="container mx-auto flex items-center justify-between px-4 py-3">
        <div className="flex items-center gap-6">
          <span className="text-gray-700 font-medium">
            {/* Assessment List */}
            {getPageTitle(location.pathname)}
          </span>
        </div>

        <div className="relative" ref={menuRef}>
          <button
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex items-center gap-2 rounded-full border border-gray-200 bg-gray-50 px-2 py-1.5 transition-colors hover:border-[#7f35b2]/40 hover:bg-[#c2a8f033] focus:outline-none focus:ring-2 focus:ring-[#7f35b2]/30"
            aria-label="User menu"
            aria-expanded={menuOpen}
            aria-haspopup="true"
          >
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-gradient-to-br from-[#7f35b2] to-[#48086f] text-sm font-semibold text-white select-none">
              {userInitial}
            </span>
            {user?.userName && (
              <span className="hidden sm:inline text-sm font-medium text-gray-700 pr-1">
                {user.userName}
              </span>
            )}
            <Bars3Icon className="h-5 w-5 text-gray-600" />
          </button>

          {menuOpen && (
            <div className="absolute right-0 mt-2 w-44 rounded-xl border border-gray-100 bg-white py-1 shadow-lg ring-1 ring-black/5 animate-[fadeIn_150ms_ease]">
              <button
                onClick={handleLogout}
                className="flex w-full items-center gap-2 px-4 py-2.5 text-sm text-gray-700 transition-colors hover:bg-red-50 hover:text-red-600"
              >
                <svg
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a2 2 0 01-2 2H6a2 2 0 01-2-2V7a2 2 0 012-2h5a2 2 0 012 2v1"
                  />
                </svg>
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}

